module.exports = __webpack_public_path__ + "img/logo_bubuia.e3004cc3.svg";